<template>
  <div class="icon-big">
    <img v-for="item in iconListbig" @click="openLink(item.link)" :src="item.url" alt="">
  </div>
</template>
<script>

export default {
  name: "index",
  data() {
    return {
      iconListbig: [
        {url: require('../../assets/icon/linkedin-balck.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../assets/icon/facebook-black.png'), link: 'https://www.facebook.com/'},
        {url: require('../../assets/icon/flipboard-balck.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../assets/icon/twitter-balck.png'), link: 'https://twitter.com/'},
        {url: require('../../assets/icon/instagram-balck.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  methods: {
    openLink(link) {
      window.open(link)
    },
  },
}

</script>
<style scoped lang="scss">
.icon-big {
  display: flex;
  margin-left: 50px;
  align-items: center;

  img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    cursor: pointer;
  }

  img:nth-child(2) {
    width: 35px;
    height: 35px;
  }

  img:nth-child(4) {
    width: 38px;
    height: 38px;
  }

  img:nth-child(5) {
    width: 38px;
    height: 38px;
  }
}

</style>